import { Component, Input, Output, EventEmitter } from '@angular/core';
import { find } from 'lodash';

@Component({
  selector: 'sc-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss'],
})
export class SelectComponent {
  @Input() collection: any;
  @Input() key: any;
  @Input() value: any;
  @Input() displaySelected: any;
  @Input() disabled: any;
  @Output() select = new EventEmitter();

  public displaySelectedValue() {
    const key = this.key || 'id';
    const selectedItem = find(this.collection, item => {
      return item[key] === this.value;
    });

    if (selectedItem) {
      return this.displaySelected
        ? this.displaySelected(selectedItem)
        : selectedItem.name;
    }
  }

  public onValueChanged() {
    this.select.emit({ value: this.value });
  }
}
